import { apiV2 } from '../axios';

export const sendSupportMessage = async (req) => {
	return await apiV2.post('/support', req);
};
